module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-23.d37c8992.png";